import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { variables } from '@indriver/yrel';
import preset from '../common-preset.js';

var headingPreset = _extends({}, preset, {
  fontSize: _extends({}, preset.fontSize, {
    xxxxl: '64px'
  }),
  lineHeight: _extends({}, preset.lineHeight, {
    xxxxl: '80px'
  }),
  margin: {
    xs: '0 0 14px 0',
    s: '0 0 16px 0',
    m: '0 0 24px 0',
    l: '0 0 32px 0',
    xl: '0 0 40px 0',
    xxl: '0 0 48px 0',
    xxxl: '0 0 56px 0',
    xxxxl: '0 0 64px 0'
  },
  fontWeight: variables['font-weight-bold']
});

var marketingHeadingPreset = _extends({}, headingPreset, {
  fontFamily: variables['font-family-landing'],
  fontSize: _extends({}, headingPreset.fontSize, {
    l: '20px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px',
    xxxxl: '96px'
  }),
  lineHeight: _extends({}, headingPreset.lineHeight, {
    l: '110%',
    xl: '110%',
    xxl: '110%',
    xxxl: '110%',
    xxxxl: '100%'
  }),
  fontWeight: variables['font-weight-regular']
});

export { headingPreset, marketingHeadingPreset };
